<span [ngClass]="{ 'warning': type === 'warning', 'success': type === 'success', 'danger': type === 'danger', 'clickable': clickable }" (click)="onClick.emit()">
    <i class="fas fa-circle-info" *ngIf="icon"></i>
    <ng-content></ng-content>
</span>
